import React from "react";
import { Link } from "react-router-dom";
import { Bot } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="md:flex md:items-center md:justify-between">
          <div className="flex items-center">
            <Bot className="h-6 w-6 text-gray-400" />
            <span className="ml-2 text-gray-500 font-medium">One80Labs</span>
          </div>
          <div className="mt-8 md:mt-0 flex flex-col items-center space-y-2">
            <div className="flex space-x-6">
              <Link
                to="/contact"
                className="text-sm text-gray-500 hover:text-[#F98B3D] transition-colors"
              >
                Contact Us
              </Link>
              <Link
                to="/privacy"
                className="text-sm text-gray-500 hover:text-[#F98B3D] transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-sm text-gray-500 hover:text-[#F98B3D] transition-colors"
              >
                Terms of Service
              </Link>
            </div>
            <p className="text-center text-sm text-gray-500">
              &copy; {new Date().getFullYear()} One80Labs. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
